import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { TenantContextService } from '../services/tenant-context.service';

/** Rota para onde quem não tem acesso é enviado. */
const ROTA_SEM_ACESSO = '/main/inicio';

/**
 * Sem `papeis` declarado → livre. `papel` `null`/`undefined` (usuário sem
 * empresa) não bloqueia — o app trata "sem empresa" por conta própria. Papel
 * desconhecido (ex.: papel novo do backend) não está em nenhuma lista, então só
 * acessa o que é livre. Também usada pelo menu lateral.
 */
export function papelPodeAcessar(
  papel: string | null | undefined,
  papeis: readonly string[] | undefined
): boolean {
  if (!papeis || !papel) {
    return true;
  }
  return papeis.includes(papel);
}

/**
 * Libera a rota pelo **papel do usuário na empresa atual**, comparando com
 * `data: { papeis: [...] }` da própria rota (sem `papeis` → livre). O backend
 * continua sendo a autorização real (`verificarPapelEmpresa`); aqui só evitamos
 * mostrar o que resultaria em 403.
 *
 * É `canActivate` (e não `canMatch`) de propósito: roda depois do
 * `companySelectionGuard` de `/main`, então a lista de empresas já está
 * resolvida. Lê `empresaAtual()` a cada navegação — trocar de empresa muda o
 * papel e a próxima navegação já respeita.
 */
export const papelGuard: CanActivateFn = route => {
  const tenant = inject(TenantContextService);
  const router = inject(Router);

  const papeis = route.data['papeis'] as readonly string[] | undefined;
  if (papelPodeAcessar(tenant.empresaAtual()?.papel, papeis)) {
    return true;
  }
  return router.parseUrl(ROTA_SEM_ACESSO);
};
